import React, { useState, useEffect } from 'react';
import { getAuthEvents } from '../firebase/db';
import { useDemo } from '../contexts/DemoContext';
import { generateDemoAuthEvents } from '../demo/demoData';
import './AuthEventLog.css';

const AuthEventLog = () => {
  const { demoMode } = useDemo();
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchEvents = async () => {
    setLoading(true);
    if (demoMode) {
      setEvents(generateDemoAuthEvents());
      setError(null);
    } else {
      const result = await getAuthEvents();
      setEvents(result.data || []);
      setError(result.error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchEvents();
  }, [demoMode]);

  const eventIcon = (type) => {
    if (type.includes('error')) return '❌';
    if (type === 'logout') return '👋';
    return '✅';
  };

  return (
    <div className="auth-event-log">
      <div className="ael-header">
        <h3>Auth Event Log</h3>
        <button onClick={fetchEvents} className="ael-refresh">Refresh</button>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <div className="ael-empty">
          <p style={{color: '#dc2626', fontStyle: 'italic'}}>⚠️ {error}</p>
          <p style={{fontSize: '13px', color: '#94a3b8'}}>
            To fix this, update your Firestore security rules to allow reading the "authEvents" collection for admins.
          </p>
        </div>
      ) : events.length === 0 ? (
        <div className="ael-empty">
          <p style={{color: '#64748b', fontStyle: 'italic'}}>No auth events logged yet.</p>
          <p style={{fontSize: '13px', color: '#94a3b8'}}>Events appear when users log in, log out, or encounter errors.</p>
        </div>
      ) : (
        <div className="ael-list">
          {events.map((e) => (
            <div key={e.id} className={`ael-row ${e.eventType?.includes('error') ? 'ael-error' : ''}`}>
              <span className="ael-icon">{eventIcon(e.eventType)}</span>
              <span className="ael-type">{e.eventType}</span>
              <span className="ael-user">{e.userEmail || (e.userId ? e.userId.slice(0, 8) : '—')}</span>
              <span className="ael-time">
                {e.timestamp?.toDate ? e.timestamp.toDate().toLocaleString() : new Date(e.timestamp).toLocaleString()}
              </span>
              {e.errorMessage && <span className="ael-err">{e.errorMessage}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AuthEventLog;
